import { EuiFlexGroup,EuiFlexItem,EuiFieldNumber, EuiSpacer, EuiButtonIcon, EuiBadge } from '@elastic/eui';
import moment from 'moment';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { GridResultsScreen } from '../Grid/GridResultsScreen';
import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';

interface Props {
  data: any;
  onFilter(año:number, mes:number): void;
}

export const TiposCambioScreen = (props: Props) => {
  const _mes = parseInt(moment().format('M')) === 1 ? 12 : parseInt(moment().format('M'))-1;
  const _año = parseInt(moment().format('M')) === 1 ? parseInt(moment().format('Y'))-1 : parseInt(moment().format('Y'));
  
  const ref:any = useRef();

  let { data, onFilter } = props;

  let [año, setAño] = useState<number>(_año);
  let [mes, setMes] = useState<number>(_mes);
  let [selected, setSelected] = useState<any>(undefined);

  useEffect(()=>{
    onRefresh()}
  ,[])

  const onChangeAño = (e:any) => {
    setAño(e.target.value)
  }

  const onChangeMes = (e:any) => {
    setMes(e.target.value)
  }

  const onRefresh = () =>{
    onFilter(año,mes)
  }

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }
  
  const onExport = () =>{
    ref.current && ref.current.onExport();
  }

  const Actions: Action[] = useMemo(()=> [
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false}
  ],[selected])


  const getForm = useMemo(() => {
    return (
      <EuiFlexGroup>
        <EuiFlexItem> 
          <EuiFlexGroup>
            <EuiFlexItem grow={false}> 
              <EuiFieldNumber placeholder="Año a filtrar ..." value={año} onChange={(e) => onChangeAño(e)} min={2010} max={3000}/>
            </EuiFlexItem> 
            <EuiFlexItem grow={false}> 
              <EuiFieldNumber placeholder="Mes a filtrar ..." value={mes} onChange={(e) => onChangeMes(e)} min={1} max={12}/>
            </EuiFlexItem>
            <EuiFlexItem grow={false} style={{justifyContent:'center'}}> 
              <EuiButtonIcon display="fill" iconType="refresh" aria-label="Recargar" onClick={()=> onRefresh()}/>
            </EuiFlexItem>
          </EuiFlexGroup>
          </EuiFlexItem>
          <EuiFlexItem> 
           <Menu actions={Actions}/>
          </EuiFlexItem> 
      </EuiFlexGroup>
    );
  },[año,mes,onChangeAño,onChangeMes])

  const getView = useMemo(() => {
    return (
      <>
        <EuiSpacer size="s" />
         <GridResultsScreen
          data={data}
          onSelected={onSelected}
          selector={false}
          menu={false}
          ref={ref}
        />
        </>
    )
  },[data, onSelected])

  return (
        <>
          {getForm}
          <EuiSpacer size="m"/>
          {getView}
        </>
  );
};

export default TiposCambioScreen;
